var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('PageHeading',{attrs:{"title":_vm.$t('not-found.title')}}),_c('section',{staticClass:"mt-4"},[_c('p',{staticStyle:{"white-space":"pre-line !important"}},[_vm._v(" "+_vm._s(_vm.$t("not-found.text"))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }